import { createStylesParamsWithDefaults } from '../PackagePicker/stylesParams';

export default createStylesParamsWithDefaults({
  showPageTitle: false,
});
